import * as Action from "@actions/index";

const InitialState = {
  status: "waiting",
  list: [],
  error: "",
};

export default function CompanySpecialization(state = InitialState, action: any) {
  switch (action.type) {
    case Action.Language.SET_LIST:
      return { ...state, list: action.data };
    case Action.Language.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Language.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Language.CLEAR:
      return { ...state, list: [] };
    default:
      return state;
  }
}
